__turbopack_context__.v({
  "header": "statblock-plugin-module__R18XZq__header",
  "statblock": "statblock-plugin-module__R18XZq__statblock",
  "subTitle": "statblock-plugin-module__R18XZq__subTitle",
  "title": "statblock-plugin-module__R18XZq__title",
});
